import graphqlClient from "../../../apollo";

class FileProvider {

    findFile(id) {
        return graphqlClient.query({
            query: require('./gql/fileFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchFiles() {
        return graphqlClient.query({
            query: require('./gql/fileFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateFiles(pageNumber, itemsPerPage, search = null, filters, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/filePaginate.graphql'),
            variables: {
                input: {
                    pageNumber, itemsPerPage, search, filters, orderBy, orderDesc
                }
            },
            fetchPolicy: "network-only"
        })
    }


    updateFile(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/fileUpdate.graphql'),
            variables: form
        })
    }

    deleteFile(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/fileDelete.graphql'),
            variables: { id }
        })
    }

    csvEtiquetasList(companyId, depositoId) {
        return graphqlClient.query({
            query: require('./gql/csvEtiquetasList.graphql'),
            variables: { companyId, depositoId },
            fetchPolicy: 'network-only'
        })
    }

    csvEtiquetasDownloadToken(companyId, depositoId, filename) {
        return graphqlClient.query({
            query: require('./gql/csvEtiquetasDownloadToken.graphql'),
            variables: { companyId, depositoId, filename },
            fetchPolicy: 'network-only'
        })
    }

    csvEtiquetasDelete(companyId, depositoId, filename) {
        return graphqlClient.mutate({
            mutation: require('./gql/csvEtiquetasDelete.graphql'),
            variables: { companyId, depositoId, filename }
        })
    }

}

const fileProvider = new FileProvider()

export default fileProvider

